export default "__VITE_ASSET__6Q8jySoq__"